import * as api from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { TransferRequest } from "@/api/williams/users";
import { useMutation, useQueryClient } from "react-query";

export function useTransferSpecialist() {
  const queryClient = useQueryClient();

  return useMutation(async (request: TransferRequest) => {
    await api.transferSpecialist(request);

    queryClient.removeQueries(queryKeys.scopeOfWork.all());
    queryClient.removeQueries(queryKeys.testEvent.all());

    queryClient.invalidateQueries(
      queryKeys.search.global({
        specialistId: request.transferFrom.id,
      })
    );
  });
}
